import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const BindDuplicateBookingRequest = (requestBody) => {

  if (requestBody?.ProductType === "Flight") {
    return {
      ReferenceNo: requestBody?.ReferenceNo,
      ProductType: requestBody?.ProductType,
      Passenger: {
        Title: requestBody?.Passenger?.title || "",
        Gender: requestBody?.Passenger?.gender || "",
        FirstName: requestBody?.Passenger?.firstName || "",
        MiddleName: requestBody?.Passenger?.middleName || "",
        LastName: requestBody?.Passenger?.lastName || "",
        DateOfBirth: requestBody?.Passenger?.dateOfBirth || "",
        PaxType: requestBody?.Passenger?.paxType || "",
      }
    };
  }
  else if (requestBody?.ProductType === "Bus") {
    debugger;
    return {
      ReferenceNo: requestBody?.ReferenceNo,
      ProductType: requestBody?.ProductType,
      Passenger: {
        Title: requestBody?.Passenger?.title || "",
        Gender: requestBody?.Passenger?.gender || "",
        FirstName: requestBody?.Passenger?.firstName || "",
        MiddleName: requestBody?.Passenger?.middleName || "",
        LastName: requestBody?.Passenger?.lastName || "",
        DateOfBirth: requestBody?.Passenger?.dateOfBirth || "",
        PaxType: requestBody?.Passenger?.paxType || "",
      }
    };
  }

  else if (requestBody?.ProductType === "Insurance") {
    debugger;
    return {
      ReferenceNo: requestBody?.ReferenceNo,
      ProductType: requestBody?.ProductType,
      Passenger: {
        Title: requestBody?.Passenger?.title || "",
        Gender: requestBody?.Passenger?.gender || "",
        FirstName: requestBody?.Passenger?.firstName || "",
        MiddleName: requestBody?.Passenger?.middleName || "",
        LastName: requestBody?.Passenger?.lastName || "",
        DateOfBirth: requestBody?.Passenger?.dateOfBirth || "",
        PaxType: requestBody?.Passenger?.paxType || "",
      }
    };
  }

  else if(requestBody?.ProductType === "Hotel"){
    return {
      ReferenceNo: requestBody?.ReferenceNo,
      ProductType: requestBody?.ProductType,
      Passenger: {
        Title: requestBody?.Passenger?.title || "",
        Gender: requestBody?.Passenger?.gender || "",
        FirstName: requestBody?.Passenger?.firstName || "",
        MiddleName: requestBody?.Passenger?.middleName || "",
        LastName: requestBody?.Passenger?.lastName || "",
        DateOfBirth: requestBody?.Passenger?.dateOfBirth || "",
        PaxType: requestBody?.Passenger?.paxType || "",
      },
      BookingInfo: {
        CheckInDate: requestBody?.BookingInfo?.CheckInDate,
        CorporateCode:  requestBody?.BookingInfo?.CorporateCode,
        //PassengerName:  requestBody?.BookingInfo?.passengerName,
        HotelName:  requestBody?.BookingInfo?.HotelName,
        City:  requestBody?.BookingInfo?.City,
        EmployeeCode:  requestBody?.BookingInfo?.EmployeeCode
      }
    };
  }

};


export const CheckDuplicateBooking = async (requestBody) => {
  try {

    const duplicateBookingRequest = BindDuplicateBookingRequest(requestBody);
    const response = await axios.post(
      `${API_BASE_URL}/api/DuplicateBooking/CheckDuplicateUserBooking`,
      duplicateBookingRequest,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    return response;

  } catch (error) {
    console.error(
      "Check Duplicate Booking Error:",
      error.response?.data || error.message
    );

    throw error;
  }
};